<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>To John Gaskill and Rany Jennette,<br/>sons of the keepers, guardians of the light</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?012aa6de